import comp from "./FeedbackInput";
export default comp;
